// userService.js
import apiClient from "./apiClient";

export const getUsers = () => apiClient.get("/users");
export const getUserById = (id) => apiClient.get(`/users/${id}`);
export const createUser = (data) => apiClient.post("/users", data);
export const updateUser = (id, data) => apiClient.put(`/users/${id}`, data);
export const deleteUser = (id) => apiClient.delete(`/users/${id}`);
export const assignUserToOffice = (userId, officeId) => apiClient.post(`/offices/${officeId}/users/${userId}`);
export const removeUserFromOffice = (userId, officeId) => apiClient.delete(`/offices/${officeId}/users/${userId}`);
export const getUserOffices = (id) => apiClient.get(`/users/${id}/roster`);
export const getMyOffices = (id) => apiClient.get(`/users/my/offices`);
export const getMyOfficeUsers = () => apiClient.get(`/users/my/office/users`);

export const getUserModules = (id, office_id = "") => apiClient
  .get(`/app-modules/user/${id}`, { params: { office_id } })
  .then(res => res);

export const getCurrentUserModules = () => apiClient
  .get(`/app-modules/current-user`)
  .then(res => res);

export const updateUserModules = (data) => apiClient.post("/user-modules/bulk", data);
export const updateUserType = (id, data) => apiClient.put(`/users/user-office/${id}`, data);